import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Stack,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  LinearProgress,
  TextField,
  MenuItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchPromotionLeaderboard } from "../../store/Slices/promotionSlice";

const METRICS = [
  { value: "approved_count", label: "Top by Approved" },
  { value: "engagement", label: "Top by Engagement" },
];

export default function PromotionLeaderboardPage() {
  const dispatch = useDispatch();
  const { leaderboard } = useSelector((s) => s.promotion);
  const [metric, setMetric] = useState("approved_count");
  const [limit, setLimit] = useState(20);

  useEffect(() => {
    dispatch(fetchPromotionLeaderboard({ metric, limit }));
  }, [dispatch, metric, limit]);

  return (
    <Box sx={{ p: 2, maxWidth: 900, mx: "auto" }}>
      <Card sx={{ borderRadius: 3, boxShadow: 6 }}>
        <CardHeader
          title="Promotion Leaderboard"
          subheader="Discover top promoters in the community"
        />
        <CardContent>
          <Stack direction="row" spacing={2} sx={{ mb: 2 }} alignItems="center">
            <ToggleButtonGroup
              size="small"
              exclusive
              value={metric}
              onChange={(_, v) => v && setMetric(v)}
            >
              {METRICS.map((m) => (
                <ToggleButton key={m.value} value={m.value}>
                  {m.label}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>

            <TextField
              select
              size="small"
              label="Limit"
              value={limit}
              onChange={(e) => setLimit(Number(e.target.value))}
              sx={{ width: 110 }}
            >
              {[10, 20, 50, 100].map((n) => (
                <MenuItem key={n} value={n}>
                  {n}
                </MenuItem>
              ))}
            </TextField>
          </Stack>

          {leaderboard.loading && <LinearProgress sx={{ mb: 2 }} />}

          <Stack spacing={1}>
            {leaderboard.rows.map((row, idx) => (
              <Box
                key={`${row._id}-${idx}`}
                sx={{
                  p: 1.5,
                  borderRadius: 2,
                  bgcolor: "action.hover",
                  display: "grid",
                  gridTemplateColumns: "50px 1fr auto",
                  gap: 2,
                }}
              >
                <Typography variant="h6" sx={{ textAlign: "center" }}>
                  {idx + 1}
                </Typography>
                <Box>
                  <Typography variant="subtitle2">
                    User ID: {row._id}
                  </Typography>
                  {row.approved_count != null && (
                    <Typography variant="body2" sx={{ opacity: 0.8 }}>
                      Approved: {row.approved_count}
                    </Typography>
                  )}
                  {row.engagement != null && (
                    <Typography variant="body2" sx={{ opacity: 0.8 }}>
                      Engagement: {Number(row.engagement).toFixed(2)}
                    </Typography>
                  )}
                </Box>
                <Box sx={{ textAlign: "right", alignSelf: "center" }}>
                  {/* مساحة لإظهار اسم المستخدم لاحقًا عبر populate إن رغبت */}
                </Box>
              </Box>
            ))}
            {!leaderboard.rows.length && !leaderboard.loading && (
              <Typography variant="body2" sx={{ opacity: 0.7 }}>
                لا توجد بيانات بعد.
              </Typography>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
